module.exports = __webpack_public_path__ + "img/shamanzs-animation-3.ec796c0a.gif";